import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getCurrentBooking } from 'redux/selectors/current_booking';
import CartBox from '../cart_box';

export function BookWithConfidence({
  bookWithConfidenceItems = [
    'Trusted company',
    '20 years experience',
    'Locally based',
  ],
}) {
  const booking = useSelector(getCurrentBooking);
  const hasCartData = booking.reservations_attributes?.length;
  const fullBookWithConfidenceItems =
    window.ecom.craftConfig.bookWithConfidenceItems || bookWithConfidenceItems;

  return (
    <CartBox
      className={`booking-confidence ${
        hasCartData ? '' : 'booking-confidence--no-booking'
      } bg-white d-none d-lg-block`}
      title="Book with confidence"
    >
      <ul className="booking-confidence__ul">
        {fullBookWithConfidenceItems &&
          fullBookWithConfidenceItems.map((bookWithConfidenceItem) => (
            <li key={bookWithConfidenceItem}>
              <i className="fas fa-check" /> {bookWithConfidenceItem}
            </li>
          ))}
      </ul>
    </CartBox>
  );
}

BookWithConfidence.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  bookWithConfidenceItems: PropTypes.array,
};
